import { ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { RouterStateUrl } from '../shared/utils';
import { getState, clearState } from '../global/session.service';
import { ActionTypes as authActionTypes } from '../features/auth/auth.actions';

import * as globalActions from '../global/actions';
import * as fromRouter from '@ngrx/router-store';
// import * as fromToaster from '../features/toaster/toaster.reducer';
import * as fromAuth from '../features/auth/auth.reducer';
import * as fromMain from '../shared/layout/main.reducer';
import * as fromTransactions from '../features/transactions/transactions.reducer';
import * as fromCashFlow from '../features/cash-flow/cash-flow.reducer';
import * as fromValuations from '../features/valuations/valuations.reducer';
import * as fromHoldings from '../features/holdings/holdings.reducer';
import * as fromStatements from '../features/statements/statements.reducer';
import * as fromDocuments from '../features/documents/documents.reducer';
import * as fromOverview from '../features/overview/overview.reducer';
import * as fromMyContacts from '../features/help-and-contacts/my-contacts/my-contacts.reducer';
import * as fromPerformance from '../features/performance/performance.reducer';
import * as fromReports from '../features/reports/reports.reducer';
import * as fromProfile from '../features/profile/profile.reducer';
import * as fromFeatures from '../features/features.reducers';
import * as fromMyConnections from '../features/help-and-contacts/my-connections/my-connections.reducer';
import * as fromEsg from '../features/esg/esg.reducers';
import * as fromTaxDetails from '../features/tax-details/tax-details.reducers';
import { AuthenticationState } from 'ngpd-merceros-authentication-fe-components/core';

export interface AppState {
  router: fromRouter.RouterReducerState<RouterStateUrl>;
  // toaster: fromToaster.State;
  auth: fromAuth.State;
  documents: fromDocuments.State;
  statements: fromStatements.State;
  transactions: fromTransactions.State;
  main: fromMain.State;
  cashFlow: fromCashFlow.State;
  valuations: fromValuations.State;
  holdings: fromHoldings.State;
  overview: fromOverview.State;
  myContacts: fromMyContacts.State;
  performance: fromPerformance.State;
  reports: fromReports.State;
  authentication: AuthenticationState;
  profile: fromProfile.State;
  features: fromFeatures.State;
  myConnections: fromMyConnections.State;
  esg: fromEsg.State;
  taxDetails: fromTaxDetails.State;
}

export const reducers: ActionReducerMap<any, any> = {
  router: fromRouter.routerReducer,
  //toaster: fromToaster.reducer,
  auth: fromAuth.reducer,
  documents: fromDocuments.reducer,
  statements: fromStatements.reducer,
  main: fromMain.reducer,
  transactions: fromTransactions.reducer,
  cashFlow: fromCashFlow.reducer,
  valuations: fromValuations.reducer,
  holdings: fromHoldings.reducer,
  overview: fromOverview.reducer,
  myContacts: fromMyContacts.reducer,
  performance: fromPerformance.reducer,
  reports: fromReports.reducer,
  profile: fromProfile.reducer,
  features: fromFeatures.reducer,
  myConnections: fromMyConnections.reducer,
  esg: fromEsg.reducer,
  taxDetails: fromTaxDetails.reducer
};


export function storeSetter(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state: AppState | undefined, action: any): AppState {
    if (action.type === '@ngrx/store/init') {
      state = getState();
      clearState();
    }

    return reducer(state, action);
  };
}

export function storeCleaner(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    if (action.type === authActionTypes.LOGOUT || action.type === globalActions.ActionTypes.CLEAR_STATE) {
      clearState();
      return reducer(undefined, action);
    }

    return reducer(state, action);
  };
}

export function logger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state: AppState | undefined, action: any): AppState {
    if (!environment.production && environment.logEverything) {
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [
  storeSetter,
  storeCleaner,
  logger
];
